export default __webpack_public_path__ + "static/media/search.fd868b4b.svg";